import { render, staticRenderFns } from "./CartMenu.vue?vue&type=template&id=7bd5d0a7&"
import script from "./CartMenu.vue?vue&type=script&lang=js&"
export * from "./CartMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd5d0a7')) {
      api.createRecord('7bd5d0a7', component.options)
    } else {
      api.reload('7bd5d0a7', component.options)
    }
    module.hot.accept("./CartMenu.vue?vue&type=template&id=7bd5d0a7&", function () {
      api.rerender('7bd5d0a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/headers/shared/CartMenu.vue"
export default component.exports